(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch ($resource) {
        var resourceUrl =  'api/_search/users-common/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
